import { IoIosArrowForward } from 'react-icons/io';

import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';
import FlightLine from 'components/FlightLine';

export const Card: any = styled.div`
  margin: 8px 16px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.PineTree}, 0.16);
  background: ${({ theme }) => theme.cardFlight.background};
  min-width: 250px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 8px 0;
  }
`;
Card.Wrapper = styled.div``;

export const Tags = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  flex: 1;
  margin-left: 10px;
`;

const tag = css`
  display: flex;
  align-items: center;
  font-size: 10px;
  border-radius: 16px;
  padding: 2px 11px 2px 14px;
  margin-bottom: 2.5px;
  width: fit-content;

  &:last-child {
    margin-top: 0;
  }

  &::after {
    content: '';
    height: 12px;
    width: 12px;
    margin-left: 7px;
    display: block;
    background-size: cover;
    background-position: center;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

export const LimitExceededTag = styled.span`
  ${tag}
  color: ${({ theme }) => theme.cardFlight.exceededColor};
  background-color: ${({ theme }) => theme.cardFlight.costExceededBackground};

  &::after {
    background-image: url('/corporate/images/exceeded-icon.svg');
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  overflow: hidden;
`;

export const Flight = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;

  &:nth-child(2) {
    margin-top: 12px;
  }
`;

export const AirlineLogo = styled(AirlineImg)`
  width: 24px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const Departure = styled.div`
  position: relative;
  width: 50px;
`;

export const Arrival = styled.div`
  position: relative;
  width: 50px;
  text-align: right;
`;

export const TurnDays = styled.span`
  position: absolute;
  right: -15px;
  top: -10px;
  width: 15px;
  font-size: 10px;
  text-align: left;
  color: ${({ theme }) => theme.cardFlight.primary};
`;

export const DepartureArrivalTime = styled.h5`
  font-weight: bold;
  color: ${ColorPalette.HEX.OuterSpace};
`;

export const Airport = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const StopsLine = styled(FlightLine)`
  width: 60px;
`;

export const TapArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 10px;
  cursor: pointer;
`;

export const RightText = styled.div`
  text-align: right;
`;

export const AirlineName = styled.span`
  font-size: 12px;
  text-align: center;
  color: ${ColorPalette.HEX.DimGray};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 75px;
`;

export const FlightLuggages = styled.div`
  & > img {
    margin: 0 1px;
  }
`;

export const Arrow = styled(IoIosArrowForward)`
  font-size: 14px;
  margin-left: 5px;
  color: ${({ theme }) => theme.cardFlight.primary} !important;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.cardFlight.border};
`;

export const PriceContainer = styled.div``;

export const Price = styled.h5`
  font-weight: 600;
  flex-shrink: 0;
  font-size: 18px;
  line-height: 20px;
  color: ${ColorPalette.HEX.CharlestonGreen};

  & > small {
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
  }
`;

export const FinalPrice = styled.span`
  font-size: 12px;
  line-height: 14px;
  font-weight: normal;
  color: ${ColorPalette.HEX.Manatee};
`;
